import validate from 'validate.js';
import checkdigit from 'checkdigit';
import i18n from '../../i18n';

validate.validators.presence.message = i18n.t('validationMessages.emptyPresence');
validate.validators.email.message = i18n.t('validationMessages.invalidEmail');

export default {
  // Base Info
  companyId: {
    presence: {allowEmpty: false}
  },
  prevCustomerId: {
    presence: {allowEmpty: false}
  },
  takeoverDate: {
    presence: {allowEmpty: false}
  },

  // Customer Info
  companyName: {},
  companyFriendlyName: {},
  legalOwnerName: {
    presence: {allowEmpty: false}
  },
  outletType: {
    presence: {allowEmpty: false}
  },
  contactName: {
    presence: {allowEmpty: false}
  },
  contactPhone: {
    presence: {allowEmpty: false},
    format: {
      pattern: /\d{8}(-\d{4})?/,
      message: i18n.t('validationMessages.invalidPhone')
    }
  },
  contactEmail: {
    presence: {allowEmpty: false},
    email: true
  },
  contactEmailConfirmation: {
    presence: {allowEmpty: false},
    email: true
  },
  season: {
    presence: {allowEmpty: false}
  },
  eventStartDate: {
    presence: {allowEmpty: false}
  },
  eventEndDate: {
    presence: {allowEmpty: false}
  },
  sellAlcohol: {
    presence: {allowEmpty: false}
  },

  // License
  license: {},

  // Delivery Info
  deliveryAddress: {
    presence: {allowEmpty: false}
  },
  deliveryZipCode: {
    presence: {allowEmpty: false},
    format: {
      pattern: /\d{4}(-\d{4})?/,
      message: i18n.t('validationMessages.invalidZipCode')
    }
  },
  deliveryCity: {
    presence: {allowEmpty: false}
  },
  deliveryDay: {
    presence: {allowEmpty: false}
  },
  preferredContactPeriod: {},
  deliveryPeriod: {},
  deliveryNotes: {},

  // Payment Info
  invoiceEmail: {
    presence: {allowEmpty: false},
    email: true
  },
  paymentRemindersEmail: {
    presence: {allowEmpty: false},
    email: true
  }
};